/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ElementsUserDetail,
    ElementsUserDetailFromJSON,
    ElementsUserDetailFromJSONTyped,
    ElementsUserDetailToJSON,
} from './';

/**
 * 
 * @export
 * @interface AuthFastLaneEndpointResponse
 */
export interface AuthFastLaneEndpointResponse {
    /**
     * 
     * @type {string}
     * @memberof AuthFastLaneEndpointResponse
     */
    redirect?: string;
    /**
     * 
     * @type {ElementsUserDetail}
     * @memberof AuthFastLaneEndpointResponse
     */
    user?: ElementsUserDetail;
}

export function AuthFastLaneEndpointResponseFromJSON(json: any): AuthFastLaneEndpointResponse {
    return AuthFastLaneEndpointResponseFromJSONTyped(json, false);
}

export function AuthFastLaneEndpointResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthFastLaneEndpointResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'redirect': !exists(json, 'redirect') ? undefined : json['redirect'],
        'user': !exists(json, 'user') ? undefined : ElementsUserDetailFromJSON(json['user']),
    };
}

export function AuthFastLaneEndpointResponseToJSON(value?: AuthFastLaneEndpointResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'redirect': value.redirect,
        'user': ElementsUserDetailToJSON(value.user),
    };
}


